import { CommonModule } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { auth as AuthGen } from '@valvur/shared-grpc';

@Component({
  standalone: true,
  selector: 'app-header-v2-avatar',
  imports: [CommonModule, TranslatePipe, InitialsPipe],
  templateUrl: './header-v2-avatar.component.html',
  styleUrl: './header-v2-avatar.component.scss',
})
export class HeaderV2AvatarComponent {
  user = input<AuthGen.User>();
}
